import {trackPromise} from "react-promise-tracker";

import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {isEmpty} from "lodash";

export const getContacts = ({customerId}, pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("getContacts")(customerId);
  return trackPromise(Call.get(url));
};
export const sendContactData = ({customerId, data}) => {
  const {id = ""} = data;
  const url = getUrl("getContacts")(customerId);
  if (!isEmpty(id.toString())) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};
export const deleteContact = ({customerId, id}) => {
  const url = getUrl("getContacts")(customerId);
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};
